import useApiService from '../utilities/useApiService';
import { useMutation, UseMutationResult } from 'react-query';
import { MutationHandlers } from '../network/models/MutationHandlers';

interface MutationVariables {
   itemId: string;
}

export const useDeleteRequestItem = (
   pharmacyId: string,
   requestId: string,
   handlers?: MutationHandlers<MutationVariables>
): [
   (itemId: string) => void,
   Omit<UseMutationResult<any, unknown, MutationVariables>, 'data' | 'mutate'>
] => {
   const { deleteMethod } = useApiService();

   const { mutate, data, ...state } = useMutation({
      mutationKey: [
         `DELETE:/pharmacies/${pharmacyId}/returnrequests/{returnRequestId}/items`,
      ],
      mutationFn: async (variables: MutationVariables) => {
         if (variables.itemId === undefined) return;

         return deleteMethod(
            `/pharmacies/${pharmacyId}/returnrequests/${requestId}/items/${variables.itemId}`
         );
      },
      onError: handlers?.onError,
      onSuccess: handlers?.onSuccess,
      onSettled: handlers?.onSettled,
      onMutate: handlers?.onMutate,
   });

   return [(itemId: string) => mutate({ itemId }), state];
};
